<div *ngIf="showForm" class="card">
    <hr />
    <h4 class="d-flex p-2 bd-highlight">Existing DJL/MPT</h4>
    <form class="form-container" [formGroup]="myDfnForm" (ngSubmit)="onSubmit()">
        <div class="form-group row">
            <div class="form-group col-md-6">
                <app-upload-file [flowName]="flowName" (uploaded)="fileUploaded($event)"></app-upload-file>
                <br />
                <p>Sample DFN File :  <span (click)="downloadFile()">ADA_DFN.xlsx  (3BMT-05-53_DFN.xlsx)</span></p>
                <button type="button" (click)="callDataCleaning()">Data cleaning</button>
            </div>      
        </div>
       
        <div class="center-first-row">
            <button type="submit" [class]="myDfnForm.invalid ? 'gray-button' : ''"
                [disabled]="data_flag">Submit</button>
        </div>

    </form>
</div>

<div *ngIf="upstream_screen">
    <app-n2p-upstream-equipment
        [inputData]="inputData"
    ></app-n2p-upstream-equipment>
</div>

<div *ngIf="smp_connectivity_flag">
  <app-smp-connectivity-n2p
    [inputData] = "inputData"
  ></app-smp-connectivity-n2p>
</div>

<div *ngIf="showMessage" class="card">
        <app-message 
            [showMessage]="showMessage"
            [MessageToShow]="MessageToShow"
            url={{url}}
            msg={{msg}}
            filename={{filename}}
        >
        </app-message>
</div>

<div *ngIf="isLoading">
    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
</div>
